import styled from 'styled-components';
import tw, { classnames, scale, height, position, borderRadius, boxShadow, padding, backgroundColor, flexWrap } from 'tailwindcss-classnames';

const commonClasses = classnames(scale('hover:scale-100' as any), height('h-auto'), position('relative', 'relative'), borderRadius('rounded-b-2xl'), boxShadow('shadow-xl', 'hover:shadow-2xl'), padding('px-0', 'pb-4'), backgroundColor('bg-gray-100'), flexWrap('flex-wrap'));

export const HorizontalContainer = (size: 'sm'|'md'|'lg') => {
    const height = size === 'md' ? '60px' :
        size === 'lg' ? '100px' :
        size === 'sm' ? '80px' : '40px';
    return styled.div.attrs({
    className: classnames(commonClasses)
})`
    min-height: ${height};
`};
